import styled, { css } from 'styled-components';
import Typography from '../../Typography';
export const FileStateContainer = styled.div `
  display: flex;
  gap: 10px;
  align-items: center;

  & ${Typography.TextMedium} {
    width: 36px;
    text-align: end;
  }
`;
export const Placeholder = styled.div `
  width: 24px;
  height: 24px;
`;
export const UploadButton = styled.div `
  width: 48px;
  height: 48px;
  background: ${({ theme }) => theme.colors.mainLight};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DropDiv = styled.div `
  width: 100%;
  height: 218px;
  position: relative;
  background: ${({ disabled, theme }) => (disabled ? theme.colors.grey01_1 : theme.colors.grey00_1)};
  border: 1px dashed ${({ theme }) => theme.colors.grey30_1};
  border-radius: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey01_1};
  }
  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
      pointer-events: none;
    `}
  & ${UploadButton} {
    ${({ disabled, theme }) => disabled && `background: ${theme.colors.grey05_1}`}
  }
  & ${Typography.TextLarge} {
    ${({ disabled, theme }) => disabled && `color: ${theme.colors.grey70_1}`}
  }
  & ${Typography.TextMedium} {
    color: ${({ disabled, theme }) => (disabled ? theme.colors.grey70_1 : theme.colors.grey100_1)};
  }
`;
export const DropDivInner = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`;
export const Filebox = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  max-height: 64px;
  padding: 20px 24px;
  border: 1px solid ${({ error, theme }) => (error ? theme.colors.critical100 : theme.colors.grey30_1)};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${Typography.TextMedium} {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const Progress = styled.div `
  width: 126px;
  border-radius: 4px;
  height: 4px;
  background: ${({ theme }) => theme.colors.grey10_1};
  overflow: hidden;
  position: relative;
  display: grid;

  &::after {
    width: ${({ progress }) => `${progress}%`};
    position: absolute;
    content: '';
    height: 100%;
    justify: {
      self: start;
    }

    background: ${({ theme }) => theme.colors.main};
    border-radius: 4px;
  }
`;
export const DropDescription = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 4px;
`;
export const MainSubText = styled.span `
  color: ${({ theme, disabled }) => (disabled ? theme.colors.grey70_1 : theme.colors.link100)};
`;
